"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "m17 17 5-5-5-5-1.41 1.41L18.17 11H9v2h9.17l-2.58 2.59z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M19 19H5V5h14v2h2V3H3v18h18v-4h-2z"
}, "1")], 'OutputSharp');